import { UserActionConst } from "../Constants/UserConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

/**
 * Fetch All Users Action
 */
export const FetchAllUsersAction = () => {
  return async (dispatch) => {
    dispatch({
      type: UserActionConst.FETCH_ALL_USERS_REQUEST,
    });

    const token = localStorage.getItem("accessToken");
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BASE_URL}${API_ENDPOINTS.ALL_USERS}`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        
        // Check for auth errors first
        if (handleAuthError(result, httpStatus, dispatch)) {
          return; // Auth error handled, don't dispatch further actions
        }
        
        if (result.statusCode === 200) {
          dispatch({
            type: UserActionConst.FETCH_ALL_USERS_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: UserActionConst.FETCH_ALL_USERS_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => {
        console.error("Fetch all users error:", error);
        dispatch({
          type: UserActionConst.FETCH_ALL_USERS_FAIL,
          result: {
            statusCode: 500,
            data: null,
            message: error.message || "Network error occurred",
            timestamp: new Date().toISOString(),
          },
        });
      });
  };
};

/**
 * Fetch Pending Users Action
 */
export const FetchPendingUsersAction = () => {
  return async (dispatch) => {
    dispatch({
      type: UserActionConst.FETCH_PENDING_USERS_REQUEST,
    });

    const token = localStorage.getItem("accessToken");
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BASE_URL}${API_ENDPOINTS.PENDING_USERS}`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        
        // Check for auth errors first
        if (handleAuthError(result, httpStatus, dispatch)) {
          return; // Auth error handled, don't dispatch further actions
        }
        
        if (result.statusCode === 200) {
          dispatch({
            type: UserActionConst.FETCH_PENDING_USERS_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: UserActionConst.FETCH_PENDING_USERS_FAIL,
            result: result,
          });
        }

      })
      .catch((error) => {
        console.error("Fetch pending users error:", error);
        dispatch({
          type: UserActionConst.FETCH_PENDING_USERS_FAIL,
          result: {
            statusCode: 500,
            data: null,
            message: error.message || "Network error occurred",
            timestamp: new Date().toISOString(),
          },
        });
      });
  };
};

/**
 * Fetch User Detail Action
 * @param {string} userId - User ID to fetch
 */
export const FetchUserDetailAction = (userId) => {
  return async (dispatch) => {
    dispatch({
      type: UserActionConst.FETCH_USER_DETAIL_REQUEST,
    });

    const token = localStorage.getItem("accessToken");
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BASE_URL}${API_ENDPOINTS.GET_USER(userId)}`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        
        // Check for auth errors first
        if (handleAuthError(result, httpStatus, dispatch)) {
          return; // Auth error handled, don't dispatch further actions
        }
        
        if (result.statusCode === 200) {
          dispatch({
            type: UserActionConst.FETCH_USER_DETAIL_SUCC,
            result: result,
          });
        } else {
          dispatch({
            type: UserActionConst.FETCH_USER_DETAIL_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => {
        console.error("Fetch user detail error:", error);
        dispatch({
          type: UserActionConst.FETCH_USER_DETAIL_FAIL,
          result: {
            statusCode: 500,
            data: null,
            message: error.message || "Network error occurred",
            timestamp: new Date().toISOString(),
          },
        });
      });
  };
};

/**
 * Approve User Action
 * @param {string} userId - User ID to approve
 */
export const ApproveUserAction = (userId) => {
  return async (dispatch) => {
    dispatch({
      type: UserActionConst.APPROVE_USER_REQUEST,
    });

    const token = localStorage.getItem("accessToken");
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BASE_URL}${API_ENDPOINTS.APPROVE_USER(userId)}`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        
        // Check for auth errors first
        if (handleAuthError(result, httpStatus, dispatch)) {
          return; // Auth error handled, don't dispatch further actions
        }
        
        if (result.statusCode === 200) {
          dispatch({
            type: UserActionConst.APPROVE_USER_SUCC,
            result: result,
            userId: userId,
          });
        } else {
          dispatch({
            type: UserActionConst.APPROVE_USER_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => {
        console.error("Approve user error:", error);
        dispatch({
          type: UserActionConst.APPROVE_USER_FAIL,
          result: {
            statusCode: 500,
            data: null,
            message: error.message || "Network error occurred",
            timestamp: new Date().toISOString(),
          },
        });
      });
  };
};

/**
 * Update User Action (Generic - for approve/reject/suspend)
 * @param {string} userId - User ID to update
 * @param {object} updateData - Data to update (e.g., { activationStatus: 'ACTIVE', isApproved: true })
 */
export const UpdateUserAction = (userId, updateData) => {
  return async (dispatch) => {
    dispatch({
      type: UserActionConst.UPDATE_USER_REQUEST,
    });

    const token = localStorage.getItem("accessToken");
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(updateData),
      redirect: "follow",
    };

    fetch(`${BASE_URL}${API_ENDPOINTS.UPDATE_USER(userId)}`, requestOptions)
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        
        // Check for auth errors first
        if (handleAuthError(result, httpStatus, dispatch)) {
          return; // Auth error handled, don't dispatch further actions
        }
        
        // Check both HTTP status code and response statusCode
        if (response.ok && (result.statusCode === 200 || result.statusCode === 201)) {
          dispatch({
            type: UserActionConst.UPDATE_USER_SUCC,
            result: result,
            userId: userId,
          });
        } else {
          dispatch({
            type: UserActionConst.UPDATE_USER_FAIL,
            result: result,
          });
        }
      })
      .catch((error) => {
        console.error("Update user error:", error);
        dispatch({
          type: UserActionConst.UPDATE_USER_FAIL,
          result: {
            statusCode: 500,
            data: null,
            message: error.message || "Network error occurred",
            timestamp: new Date().toISOString(),
          },
        });
      });
  };
};

